module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event_detail_location_and_studio-755f5ea5a8176e62a4da89067239e5f4.jpg";